import React, { useState, useEffect } from 'react';
import './PossiblePlacesModal.scss';
import { FormattedMessage, IntlProvider, useIntl } from 'react-intl';
import { Grid, Modal, Button, RadioButton, TextInput, Dropdown } from '../../../../../canvasComponents/index';
import { stateUSA, provinceCanada, countries } from './DummyData';
// messages
import messages from './messages';

export function PossiblePlacesModal({ showModal, setShowModal, possiblePlaces, setFinalAddress, localParams }) {
  const intl = useIntl();
  const [radioButtonValue, setRadioButtonValue] = useState('');
  const [acceptedAddress, setAcceptedAddress] = useState({
    street: '',
    streetName: '',
    city: '',
    country: 'CA',
    province: '',
    state: '',
    postalCode: '',
    zipCode: '',
  });

  const [errors, setErrors] = useState({
    errorRequired: '',
    errorCity: '',
    errorProvince: '',
    errorState: '',
  });

  const addressHandler = (e, fieldName) => {
    if (fieldName === 'country') {
      setAcceptedAddress((prevState) => ({
        ...prevState,
        [fieldName]: e,
        province: '',
        state: '',
      }));
    } else {
      setAcceptedAddress((prevState) => ({
        ...prevState,
        [fieldName]: e,
      }));
    }
  };

  const handleValidation = () => {
    let formIsValid = true;

    if (radioButtonValue === 'noneOfTheAbove') {
      if (acceptedAddress.city.trim() === '') {
        setErrors((prevState) => ({
          ...prevState,
          errorCity: 'Oops! Looks like you forgot to fill this in.',
        }));
        formIsValid = false;
      } else {
        setErrors((prevState) => ({
          ...prevState,
          errorCity: '',
        }));
      }

      if (acceptedAddress.country === 'CA') {
        if (acceptedAddress.province === '') {
          setErrors((prevState) => ({
            ...prevState,
            errorProvince: 'Oops! Looks like you forgot to fill this in.',
          }));
          formIsValid = false;
        } else {
          setErrors((prevState) => ({
            ...prevState,
            errorProvince: '',
          }));
        }
      } else if (acceptedAddress.state === '') {
        setErrors((prevState) => ({
          ...prevState,
          errorState: 'Oops! Looks like you forgot to fill this in.',
        }));
        formIsValid = false;
      } else {
        setErrors((prevState) => ({
          ...prevState,
          errorState: '',
        }));
      }
    } else if (radioButtonValue === '') {
      setErrors((prevState) => ({
        ...prevState,
        errorRequired: 'Oops! Looks like you forgot to fill this in.',
      }));
      formIsValid = false;
    } else {
      setErrors((prevState) => ({
        ...prevState,
        errorRequired: '',
      }));
    }

    return formIsValid;
  };

  const translateOptions = (options) => {
    const newOptions = options.map((element) => ({
      selectedLabel: `${intl.formatMessage({ id: `${element.selectedLabel}`, defaultValue: `${element.selectedLabel}` })}`,
      label: `${intl.formatMessage({ id: `${element.label}`, defaultValue: `${element.label}` })}`,
      value: element.value,
    }));
    return newOptions;
  };

  const saveAddress = () => {
    if (handleValidation() && radioButtonValue === 'noneOfTheAbove') {
      setFinalAddress(acceptedAddress, 'modal');
      cleanAddress(false);
    } else if (handleValidation() && radioButtonValue !== 'noneOfTheAbove') {
      setFinalAddress(acceptedAddress, 'map');
      cleanAddress(false);
    }
  };

  const cleanAddress = (sm) => {
    setAcceptedAddress({
      street: '',
      streetName: '',
      city: '',
      country: 'CA',
      province: '',
      state: '',
      postalCode: '',
      zipCode: '',
    });
    setErrors({
      errorRequired: '',
      errorCity: '',
      errorProvince: '',
      errorState: '',
    });
    if (!sm) { setShowModal(sm); }
  };

  const closeModal = () => {
    setRadioButtonValue('');
    cleanAddress(false);
  };

  const changeAcceptedAddress = (option) => {
    const tempAcceptedAddress = possiblePlaces.find((p) => p.value === option);
    setAcceptedAddress(tempAcceptedAddress);
    setRadioButtonValue(option);
  };

  useEffect(() => {
    setRadioButtonValue('');
    cleanAddress(true);
  }, [possiblePlaces]);

  useEffect(() => {
    if (radioButtonValue !== 'noneOfTheAbove' && radioButtonValue !== '') {
      changeAcceptedAddress(radioButtonValue);
    } else {
      setAcceptedAddress({
        street: '',
        streetName: '',
        city: '',
        country: 'CA',
        province: '',
        state: '',
        postalCode: '',
        zipCode: '',
      });
    }
  }, [radioButtonValue]);

  return showModal ? (
    <IntlProvider locale={localParams.lang} messages={localParams.i18n}>
      <Modal
        id="possibleplaces-modal"
        isOpen={showModal}
        onRequestClose={() => closeModal()}
      >
        <Grid>
          <Grid.Row mb4>
            <span className="possibleplaces-modal-title"><FormattedMessage {...messages.justChecking} /></span>
            <span className="possibleplaces-modal-sub-title"><FormattedMessage {...messages.matchedUp} /></span>
          </Grid.Row>
          <Grid.Row mb2>
            {possiblePlaces.length && possiblePlaces.map((possiblePlace) => (
              <RadioButton
                secondary
                id={`radiobutton_${Math.random() * 0xffffffffffff}`}
                key={`key_radiobutton_${Math.random() * 0xffffffffffff}`}
                value={possiblePlace.value}
                onChange={(v) => setRadioButtonValue(v)}
                checked={radioButtonValue === possiblePlace.value}
              >
                {possiblePlace.value}
              </RadioButton>
            ))}
            <RadioButton
              secondary
              id={`radiobutton_${Math.random() * 0xffffffffffff}`}
              key={`key_radiobutton_${Math.random() * 0xffffffffffff}`}
              value="noneOfTheAbove"
              onChange={(v) => setRadioButtonValue(v)}
              checked={radioButtonValue === 'noneOfTheAbove'}
            >
              <FormattedMessage {...messages.noneOfTheAbove} />
            </RadioButton>
            {errors.errorRequired !== '' && (
            <span
              style={{
                marginLeft: '3px',
                fontSize: '14px',
                color: 'rgb(177, 2, 2)',
              }}
            >
              <FormattedMessage id={errors.errorRequired} defaultMessage={errors.errorRequired} />
            </span>
            )}
          </Grid.Row>
          {radioButtonValue === 'noneOfTheAbove' ? (
            <>
              <Grid.Row>
                <span className="possibleplaces-modal-sub-title"><FormattedMessage {...messages.fillInDetails} /></span>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column colMd5>
                  <label htmlFor="street" className="modal-label">
                    <FormattedMessage {...messages.street} />
                  </label>
                  <TextInput
                    name="street"
                    number
                    defaultValue={acceptedAddress.street || ''}
                    onChange={(v) => addressHandler(v, 'street')}
                  />
                </Grid.Column>
                <Grid.Column colMd7>
                  <label htmlFor="streetName" className="modal-label">
                    <FormattedMessage {...messages.streetName} />
                  </label>
                  <TextInput
                    name="streetName"
                    defaultValue={acceptedAddress.streetName || ''}
                    onChange={(v) => addressHandler(v, 'streetName')}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column colMd6>
                  <label htmlFor="city" className="modal-label">
                    <FormattedMessage {...messages.city} />
                  </label>
                  <TextInput
                    name="city"
                    defaultValue={acceptedAddress.city || ''}
                    onChange={(v) => addressHandler(v, 'city')}
                  />
                  {errors.errorCity !== '' && (
                  <span
                    style={{
                      marginLeft: '3px',
                      fontSize: '14px',
                      color: 'rgb(177, 2, 2)',
                    }}
                  >
                    <FormattedMessage id={errors.errorCity} defaultMessage={errors.errorCity} />
                  </span>
                  )}
                </Grid.Column>
                <Grid.Column colMd6>
                  <label htmlFor="country" className="modal-label">
                    <FormattedMessage {...messages.country} />
                  </label>
                  <Dropdown
                    id="country"
                    name="country"
                    primary
                    value={acceptedAddress.country || 'CA'}
                    onChange={(value) => addressHandler(value, 'country')}
                    options={translateOptions(countries)}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column colMd6>
                  {acceptedAddress.country === 'CA' ? (
                    <>
                      <label htmlFor="province" className="modal-label"><FormattedMessage {...messages.province} /></label>
                      <Dropdown
                        id="province"
                        name="province"
                        primary
                        value={acceptedAddress.province || ''}
                        onChange={(value) => addressHandler(value, 'province')}
                        options={translateOptions(provinceCanada)}
                      />
                      {errors.errorProvince !== '' && (
                      <span
                        style={{
                          marginLeft: '3px',
                          fontSize: '14px',
                          color: 'rgb(177, 2, 2)',
                        }}
                      >
                        <FormattedMessage id={errors.errorProvince} defaultMessage={errors.errorProvince} />
                      </span>
                      )}
                    </>
                  ) : (
                    <>
                      <label htmlFor="state"><FormattedMessage {...messages.state} /></label>
                      <Dropdown
                        id="state"
                        name="state"
                        primary
                        onChange={(value) => addressHandler(value, 'state')}
                        value={
                          acceptedAddress.country === 'US' ? acceptedAddress.state || '' : 'Other'
                          }
                        options={
                          acceptedAddress.country === 'US'
                            ? stateUSA
                            : [
                              {
                                selectedLabel: 'Other',
                                label: 'Other',
                                value: 'Other',
                              },
                            ]
                          }
                      />
                      {errors.errorState !== '' && (
                      <span
                        style={{
                          marginLeft: '3px',
                          fontSize: '14px',
                          color: 'rgb(177, 2, 2)',
                        }}
                      >
                        <FormattedMessage id={errors.errorState} defaultMessage={errors.errorState} />
                      </span>
                      )}
                    </>
                  )}
                </Grid.Column>
                <Grid.Column colMd6>
                  {acceptedAddress.country === 'CA' ? (
                    <>
                      <label htmlFor="postalCode" className="modal-label"><FormattedMessage {...messages.postalCode} /></label>
                      <TextInput
                        name="postalCode"
                        defaultValue={acceptedAddress.postalCode || ''}
                        onChange={(v) => addressHandler(v, 'postalCode')}
                      />
                    </>
                  ) : (
                    <>
                      <label htmlFor="zipCode"><FormattedMessage {...messages.zipCode} /></label>
                      <TextInput
                        name="zipCode"
                        defaultValue={acceptedAddress.zipCode || ''}
                        onChange={(v) => addressHandler(v, 'zipCode')}
                      />
                    </>
                  )}
                </Grid.Column>
              </Grid.Row>

            </>
          ) : null}
          <Grid.Row mt2>
            <Button
              primary
              id="saveAddressButton"
              onClick={() => saveAddress()}
            >
              {radioButtonValue !== 'noneOfTheAbove' ? <FormattedMessage {...messages.continueNewAddress} /> : <FormattedMessage {...messages.saveNewAddress} />}
            </Button>
          </Grid.Row>
          <Grid.Row>
            <Button
              className="black-underline-button"
              style={{ marginTop: '20px' }}
              id="cancelButton"
              onClick={() => cleanAddress(false)}
            >
              <FormattedMessage {...messages.cancel} />
            </Button>

          </Grid.Row>
        </Grid>
      </Modal>
    </IntlProvider>
  ) : null;
}
